import { formatNumber } from "lib/helpers/format";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

const OrderBook = ({ tokenDetail }: { tokenDetail: any }) => {

  const {t} = useTranslation()
  
  const [randomNumber, setRandomNumber] = useState(0);

  function getRandomNumber(decimals = 6) {
    return parseFloat(Math.random().toFixed(decimals));
  }
  function getRandomAmount(min: number, max: number, decimals = 4) {
    const randomNumber = Math.random() * (max - min) + min;
    return formatNumber(randomNumber.toFixed(decimals));
  }

  useEffect(() => {
    const interval = setInterval(() => {
      setRandomNumber(new Date().getTime());
    }, 1000);

    return () => clearInterval(interval);
  }, [tokenDetail]);

  function getRandomChange() {
    // Tạo một số ngẫu nhiên trong khoảng từ -0.0002 đến 0.0002
    return (Math.random() - 0.2) / 2500;
  }
  function updateValue(currentValue: any) {
    return currentValue += getRandomChange();
  }
  return (
    <div className="vksPkWSVZbb8qV7M89kC">
      <div className="CardWrapper-sc-jzilk8-0 bPgSXQ">
        <div
          className="CardBodyWrapper-sc-jzilk8-4 cJpVry"
          style={{
            overflow: "hidden",
            borderRadius: "0px 0px 4px 4px",
          }}
        >
          <div className="mqvhB_oTeDfxjwWXjkta">
            <ul className="V0C8z0eCpP7pVsEplMty">
              <li className="Z4l6qEpBliiWvzLByjnQ">{t("Sổ lệnh")}</li>
              <li className=" ">{t("Giao dịch")}</li>
            </ul>
            <div>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 24 24"
                fill="currentColor"
                aria-hidden="true"
                className="RnGnvYXSgSvnHjrP85cm"
                style={{ color: "var(--content-tertiary)" }}
              >
                <path d="M3.75 8.25h3.094a3 3 0 005.812 0h7.594a.75.75 0 100-1.5h-7.594a3 3 0 00-5.812 0H3.75a.75.75 0 000 1.5zm6-2.25a1.5 1.5 0 110 3 1.5 1.5 0 010-3zm10.5 9.75h-1.594a3 3 0 00-5.812 0H3.75a.75.75 0 100 1.5h9.094a3 3 0 005.812 0h1.594a.75.75 0 000-1.5zM15.75 18a1.5 1.5 0 110-3 1.5 1.5 0 010 3z" />
              </svg>
            </div>
          </div>
          <div
            className="w-full pt-[6px]"
            style={{ height: "calc(100% - 40px)" }}
          >
            <ul className="StyledTableHeader-sc-3kpmlb-0 dJtHJR text-[#8e8e92] flex">
              <li
                className="StyledTableCell-sc-3kpmlb-1 hOxmFC flex-1 content-center justify-between flex-wrap h-[20px] relative cursor-pointer hover-bg mx-[6px]"
                style={{ marginRight: 0, paddingRight: 0 }}
              >
                {t("Giá")} (USDT)
              </li>
              <li
                className="StyledTableCell-sc-3kpmlb-1 hUndfm flex-1 content-center justify-between flex-wrap h-[20px] relative cursor-pointer hover-bg mx-[6px]"
                style={{ marginRight: 4, paddingRight: 0 }}
              >
                {t("Số lượng")} ({tokenDetail.symbol})
              </li>
              <li
                className="StyledTableCell-sc-3kpmlb-1 hUndfm flex-1 text-right !pr-1 flex-wrap h-[20px] relative cursor-pointer hover-bg mx-[6px]"
                style={{ marginRight: 0, paddingRight: 0 }}
              >
                {t("Khối lượng")}
              </li>
            </ul>
            <div className="Px7Opme544YlwvahfRwx">
              <div className="bj3ny71RBfDxEisyLBeI">
                <div className="" style={{ marginTop: 0 }}>
                  <div className="flex content-center justify-between flex-wrap h-[20px] relative cursor-pointer hover-bg mx-[6px]">
                    <ul className="flex justify-between items-center content-center text-[12px] px-[6px] w-full">
                      <li className="w-[30%] text-left t3UMhdLTbuvvf6XjWeTf">
                        {formatNumber(
                          (tokenDetail.quote.USD.price * 1.125).toFixed(4)
                        )}
                      </li>
                      <li className="text-secondaryText text-right w-[35%] mr-2">
                        {getRandomNumber()}
                      </li>
                      <li className="text-secondaryText text-right w-[35%]">
                        {getRandomAmount(40884, 44884)}
                      </li>
                    </ul>
                    <div
                      className="absolute h-full transition-[all] duration-300 ease-out border-x-0 border-solid border-t-1 border-b-1 border-t-headerWhiteMain border-b-headerWhiteMain box-border pointer-events-none XJZtwxk4j4Cy794j1Gpx ZYNLXtcs4UMYH4zjYvyD"
                      style={{
                        width: `${getRandomAmount(12, 22)}%`,
                      }}
                    />
                  </div>
                </div>
                <div className="" style={{ marginTop: 1 }}>
                  <div className="flex content-center justify-between flex-wrap h-[20px] relative cursor-pointer hover-bg mx-[6px]">
                    <ul className="flex justify-between items-center content-center text-[12px] px-[6px] w-full">
                      <li className="w-[30%] text-left t3UMhdLTbuvvf6XjWeTf">
                        {formatNumber(
                          (tokenDetail.quote.USD.price * 1.12).toFixed(4)
                        )}
                      </li>
                      <li className="text-secondaryText text-right w-[35%] mr-2">
                        {getRandomNumber()}
                      </li>
                      <li className="text-secondaryText text-right w-[35%]">
                        {getRandomAmount(140, 178)}
                      </li>
                    </ul>
                    <div
                      className="absolute h-full transition-[all] duration-300 ease-out border-x-0 border-solid border-t-1 border-b-1 border-t-headerWhiteMain border-b-headerWhiteMain box-border pointer-events-none XJZtwxk4j4Cy794j1Gpx ZYNLXtcs4UMYH4zjYvyD"
                      style={{
                        width: `${getRandomAmount(0, 20)}%`,
                      }}
                    />
                  </div>
                </div>
                <div className="" style={{ marginTop: 1 }}>
                  <div className="flex content-center justify-between flex-wrap h-[20px] relative cursor-pointer hover-bg mx-[6px]">
                    <ul className="flex justify-between items-center content-center text-[12px] px-[6px] w-full">
                      <li className="w-[30%] text-left t3UMhdLTbuvvf6XjWeTf">
                        {formatNumber(
                          (tokenDetail.quote.USD.price * 1.1).toFixed(4)
                        )}
                      </li>
                      <li className="text-secondaryText text-right w-[35%] mr-2">
                        {getRandomNumber()}
                      </li>
                      <li className="text-secondaryText text-right w-[35%]">
                        {getRandomAmount(10000, 17800)}
                      </li>
                    </ul>
                    <div
                      className="absolute h-full transition-[all] duration-300 ease-out border-x-0 border-solid border-t-1 border-b-1 border-t-headerWhiteMain border-b-headerWhiteMain box-border pointer-events-none XJZtwxk4j4Cy794j1Gpx ZYNLXtcs4UMYH4zjYvyD"
                      style={{
                        width: `${getRandomAmount(4, 32)}%`,
                      }}
                    />
                  </div>
                </div>
                <div className="" style={{ marginTop: 1 }}>
                  <div className="flex content-center justify-between flex-wrap h-[20px] relative cursor-pointer hover-bg mx-[6px]">
                    <ul className="flex justify-between items-center content-center text-[12px] px-[6px] w-full">
                      <li className="w-[30%] text-left t3UMhdLTbuvvf6XjWeTf">
                        {formatNumber(
                          (tokenDetail.quote.USD.price * 1.08).toFixed(4)
                        )}
                      </li>
                      <li className="text-secondaryText text-right w-[35%] mr-2">
                        {getRandomNumber()}
                      </li>
                      <li className="text-secondaryText text-right w-[35%]">
                        {getRandomAmount(40000, 47800)}
                      </li>
                    </ul>
                    <div
                      className="absolute h-full transition-[all] duration-300 ease-out border-x-0 border-solid border-t-1 border-b-1 border-t-headerWhiteMain border-b-headerWhiteMain box-border pointer-events-none XJZtwxk4j4Cy794j1Gpx ZYNLXtcs4UMYH4zjYvyD"
                      style={{
                        width: `${getRandomAmount(15, 67)}%`,
                      }}
                    />
                  </div>
                </div>
                <div className="" style={{ marginTop: 1 }}>
                  <div className="flex content-center justify-between flex-wrap h-[20px] relative cursor-pointer hover-bg mx-[6px]">
                    <ul className="flex justify-between items-center content-center text-[12px] px-[6px] w-full">
                      <li className="w-[30%] text-left t3UMhdLTbuvvf6XjWeTf">
                        {formatNumber(
                          (tokenDetail.quote.USD.price * 1.065).toFixed(4)
                        )}
                      </li>
                      <li className="text-secondaryText text-right w-[35%] mr-2">
                        {getRandomNumber()}
                      </li>
                      <li className="text-secondaryText text-right w-[35%]">
                        {getRandomAmount(6000, 7800)}
                      </li>
                    </ul>
                    <div
                      className="absolute h-full transition-[all] duration-300 ease-out border-x-0 border-solid border-t-1 border-b-1 border-t-headerWhiteMain border-b-headerWhiteMain box-border pointer-events-none XJZtwxk4j4Cy794j1Gpx ZYNLXtcs4UMYH4zjYvyD"
                      style={{
                        width: `${getRandomAmount(40, 60)}%`,
                      }}
                    />
                  </div>
                </div>
                <div className="" style={{ marginTop: 1 }}>
                  <div className="flex content-center justify-between flex-wrap h-[20px] relative cursor-pointer hover-bg mx-[6px]">
                    <ul className="flex justify-between items-center content-center text-[12px] px-[6px] w-full">
                      <li className="w-[30%] text-left t3UMhdLTbuvvf6XjWeTf">
                        {formatNumber(
                          (tokenDetail.quote.USD.price * 1.05).toFixed(4)
                        )}
                      </li>
                      <li className="text-secondaryText text-right w-[35%] mr-2">
                        {getRandomNumber()}
                      </li>
                      <li className="text-secondaryText text-right w-[35%]">
                        {getRandomAmount(6000, 7800)}
                      </li>
                    </ul>
                    <div
                      className="absolute h-full transition-[all] duration-300 ease-out border-x-0 border-solid border-t-1 border-b-1 border-t-headerWhiteMain border-b-headerWhiteMain box-border pointer-events-none XJZtwxk4j4Cy794j1Gpx ZYNLXtcs4UMYH4zjYvyD"
                      style={{
                        width: `${getRandomAmount(25, 40)}%`,
                      }}
                    />
                  </div>
                </div>
                <div className="" style={{ marginTop: 1 }}>
                  <div className="flex content-center justify-between flex-wrap h-[20px] relative cursor-pointer hover-bg mx-[6px]">
                    <ul className="flex justify-between items-center content-center text-[12px] px-[6px] w-full">
                      <li className="w-[30%] text-left t3UMhdLTbuvvf6XjWeTf">
                        {formatNumber(
                          (tokenDetail.quote.USD.price * 1.04).toFixed(4)
                        )}
                      </li>
                      <li className="text-secondaryText text-right w-[35%] mr-2">
                        {getRandomNumber()}
                      </li>
                      <li className="text-secondaryText text-right w-[35%]">
                        {getRandomAmount(2000, 3800)}
                      </li>
                    </ul>
                    <div
                      className="absolute h-full transition-[all] duration-300 ease-out border-x-0 border-solid border-t-1 border-b-1 border-t-headerWhiteMain border-b-headerWhiteMain box-border pointer-events-none XJZtwxk4j4Cy794j1Gpx ZYNLXtcs4UMYH4zjYvyD"
                      style={{
                        width: `${getRandomAmount(60, 100)}%`,
                      }}
                    />
                  </div>
                </div>
                <div className="" style={{ marginTop: 1 }}>
                  <div className="flex content-center justify-between flex-wrap h-[20px] relative cursor-pointer hover-bg mx-[6px]">
                    <ul className="flex justify-between items-center content-center text-[12px] px-[6px] w-full">
                      <li className="w-[30%] text-left t3UMhdLTbuvvf6XjWeTf">
                        {formatNumber(
                          (tokenDetail.quote.USD.price * 1.03).toFixed(4)
                        )}
                      </li>
                      <li className="text-secondaryText text-right w-[35%] mr-2">
                        {getRandomNumber()}
                      </li>
                      <li className="text-secondaryText text-right w-[35%]">
                        {getRandomAmount(200000, 580000)}
                      </li>
                    </ul>
                    <div
                      className="absolute h-full transition-[all] duration-300 ease-out border-x-0 border-solid border-t-1 border-b-1 border-t-headerWhiteMain border-b-headerWhiteMain box-border pointer-events-none XJZtwxk4j4Cy794j1Gpx ZYNLXtcs4UMYH4zjYvyD"
                      style={{
                        width: `${getRandomAmount(65, 100)}%`,
                      }}
                    />
                  </div>
                </div>
                <div className="" style={{ marginTop: 1 }}>
                  <div className="flex content-center justify-between flex-wrap h-[20px] relative cursor-pointer hover-bg mx-[6px]">
                    <ul className="flex justify-between items-center content-center text-[12px] px-[6px] w-full">
                      <li className="w-[30%] text-left t3UMhdLTbuvvf6XjWeTf">
                        {formatNumber(
                          (tokenDetail.quote.USD.price * 1.02).toFixed(4)
                        )}
                      </li>
                      <li className="text-secondaryText text-right w-[35%] mr-2">
                        {getRandomNumber()}
                      </li>
                      <li className="text-secondaryText text-right w-[35%]">
                        {getRandomAmount(2000, 5000)}
                      </li>
                    </ul>
                    <div
                      className="absolute h-full transition-[all] duration-300 ease-out border-x-0 border-solid border-t-1 border-b-1 border-t-headerWhiteMain border-b-headerWhiteMain box-border pointer-events-none XJZtwxk4j4Cy794j1Gpx ZYNLXtcs4UMYH4zjYvyD"
                      style={{
                        width: `${getRandomAmount(0, 51)}%`,
                      }}
                    />
                  </div>
                </div>
                <div className="" style={{ marginTop: 1 }}>
                  <div className="flex content-center justify-between flex-wrap h-[20px] relative cursor-pointer hover-bg mx-[6px]">
                    <ul className="flex justify-between items-center content-center text-[12px] px-[6px] w-full">
                      <li className="w-[30%] text-left t3UMhdLTbuvvf6XjWeTf">
                        {formatNumber(
                          (tokenDetail.quote.USD.price * 1.01).toFixed(4)
                        )}
                      </li>
                      <li className="text-secondaryText text-right w-[35%] mr-2">
                        {getRandomNumber()}
                      </li>
                      <li className="text-secondaryText text-right w-[35%]">
                        {getRandomAmount(2000, 9000)}
                      </li>
                    </ul>
                    <div
                      className="absolute h-full transition-[all] duration-300 ease-out border-x-0 border-solid border-t-1 border-b-1 border-t-headerWhiteMain border-b-headerWhiteMain box-border pointer-events-none XJZtwxk4j4Cy794j1Gpx ZYNLXtcs4UMYH4zjYvyD"
                      style={{
                        width: `${getRandomAmount(0, 33)}%`,
                      }}
                    />
                  </div>
                </div>
              </div>
              <div className="u0bRmvJYENbdRlboVoTI">
                <div className="Qli_vvlOYiL1FYoWmEtm">
                  <div className="rOnTaeHLYOYax3pIUjr7 t3UMhdLTbuvvf6XjWeTf">
                    <span>
                      {formatNumber(updateValue(tokenDetail.quote.USD.price).toFixed(4))}
                    </span>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 24 24"
                      fill="currentColor"
                      aria-hidden="true"
                      className="w-[16px] h-[16px]"
                      style={{
                        color: "var(--content-trade-sell)",
                        marginInlineStart: 8,
                      }}
                    >
                      <path d="M19.28 14.03l-6.75 6.75a.75.75 0 01-1.06 0l-6.75-6.75a.75.75 0 111.06-1.06l5.47 5.47V3.75a.75.75 0 111.5 0v14.69l5.47-5.47a.75.75 0 111.06 1.06z" />
                    </svg>
                  </div>
                  
                </div>
              </div>
              <div className="DucjjuqM2nt_HpBQzwUj">
                <div className="" style={{ marginTop: 0 }}>
                  <div className="flex content-center justify-between flex-wrap h-[20px] relative cursor-pointer hover-bg mx-[6px]">
                    <ul className="flex justify-between items-center content-center text-[12px] px-[6px] w-full">
                      <li className="w-[30%] text-left iM4qYuTmSKgPwRPj1yPH">
                        {formatNumber(
                          (tokenDetail.quote.USD.price * 0.99).toFixed(4)
                        )}
                      </li>
                      <li className="text-secondaryText text-right w-[35%] mr-2">
                        {getRandomNumber()}
                      </li>
                      <li className="text-secondaryText text-right w-[35%]">
                        {getRandomAmount(7000, 11000)}
                      </li>
                    </ul>
                    <div
                      className="absolute h-full transition-[all] duration-300 ease-out border-x-0 border-solid border-t-1 border-b-1 border-t-headerWhiteMain border-b-headerWhiteMain box-border pointer-events-none I6XCSVa72KszoscrLtcH ZYNLXtcs4UMYH4zjYvyD"
                      style={{
                        width: `${getRandomAmount(0, 60)}%`,
                      }}
                    />
                  </div>
                </div>
                <div className="" style={{ marginTop: 1 }}>
                  <div className="flex content-center justify-between flex-wrap h-[20px] relative cursor-pointer hover-bg mx-[6px]">
                    <ul className="flex justify-between items-center content-center text-[12px] px-[6px] w-full">
                      <li className="w-[30%] text-left iM4qYuTmSKgPwRPj1yPH">
                        {formatNumber(
                          (tokenDetail.quote.USD.price * 0.982).toFixed(4)
                        )}
                      </li>
                      <li className="text-secondaryText text-right w-[35%] mr-2">
                        {getRandomNumber()}
                      </li>
                      <li className="text-secondaryText text-right w-[35%]">
                        {getRandomAmount(17000, 21000)}
                      </li>
                    </ul>
                    <div
                      className="absolute h-full transition-[all] duration-300 ease-out border-x-0 border-solid border-t-1 border-b-1 border-t-headerWhiteMain border-b-headerWhiteMain box-border pointer-events-none I6XCSVa72KszoscrLtcH ZYNLXtcs4UMYH4zjYvyD"
                      style={{
                        width: `${getRandomAmount(40, 90)}%`,
                      }}
                    />
                  </div>
                </div>
                <div className="" style={{ marginTop: 1 }}>
                  <div className="flex content-center justify-between flex-wrap h-[20px] relative cursor-pointer hover-bg mx-[6px]">
                    <ul className="flex justify-between items-center content-center text-[12px] px-[6px] w-full">
                      <li className="w-[30%] text-left iM4qYuTmSKgPwRPj1yPH">
                        {formatNumber(
                          (tokenDetail.quote.USD.price * 0.975).toFixed(4)
                        )}
                      </li>
                      <li className="text-secondaryText text-right w-[35%] mr-2">
                        {getRandomNumber()}
                      </li>
                      <li className="text-secondaryText text-right w-[35%]">
                        {getRandomAmount(81000, 101000)}
                      </li>
                    </ul>
                    <div
                      className="absolute h-full transition-[all] duration-300 ease-out border-x-0 border-solid border-t-1 border-b-1 border-t-headerWhiteMain border-b-headerWhiteMain box-border pointer-events-none I6XCSVa72KszoscrLtcH ZYNLXtcs4UMYH4zjYvyD"
                      style={{
                        width: `${getRandomAmount(20, 46)}%`,
                      }}
                    />
                  </div>
                </div>
                <div className="" style={{ marginTop: 1 }}>
                  <div className="flex content-center justify-between flex-wrap h-[20px] relative cursor-pointer hover-bg mx-[6px]">
                    <ul className="flex justify-between items-center content-center text-[12px] px-[6px] w-full">
                      <li className="w-[30%] text-left iM4qYuTmSKgPwRPj1yPH">
                        {formatNumber(
                          (tokenDetail.quote.USD.price * 0.962).toFixed(4)
                        )}
                      </li>
                      <li className="text-secondaryText text-right w-[35%] mr-2">
                        {getRandomNumber()}
                      </li>
                      <li className="text-secondaryText text-right w-[35%]">
                        {getRandomAmount(8000, 10100)}
                      </li>
                    </ul>
                    <div
                      className="absolute h-full transition-[all] duration-300 ease-out border-x-0 border-solid border-t-1 border-b-1 border-t-headerWhiteMain border-b-headerWhiteMain box-border pointer-events-none I6XCSVa72KszoscrLtcH ZYNLXtcs4UMYH4zjYvyD"
                      style={{
                        width: `${getRandomAmount(10, 66)}%`,
                      }}
                    />
                  </div>
                </div>
                <div className="" style={{ marginTop: 1 }}>
                  <div className="flex content-center justify-between flex-wrap h-[20px] relative cursor-pointer hover-bg mx-[6px]">
                    <ul className="flex justify-between items-center content-center text-[12px] px-[6px] w-full">
                      <li className="w-[30%] text-left iM4qYuTmSKgPwRPj1yPH">
                        {formatNumber(
                          (tokenDetail.quote.USD.price * 0.954).toFixed(4)
                        )}
                      </li>
                      <li className="text-secondaryText text-right w-[35%] mr-2">
                        {getRandomNumber()}
                      </li>
                      <li className="text-secondaryText text-right w-[35%]">
                        {getRandomAmount(1000, 2100)}
                      </li>
                    </ul>
                    <div
                      className="absolute h-full transition-[all] duration-300 ease-out border-x-0 border-solid border-t-1 border-b-1 border-t-headerWhiteMain border-b-headerWhiteMain box-border pointer-events-none I6XCSVa72KszoscrLtcH ZYNLXtcs4UMYH4zjYvyD"
                      style={{
                        width: `${getRandomAmount(0, 40)}%`,
                      }}
                    />
                  </div>
                </div>
                <div className="" style={{ marginTop: 1 }}>
                  <div className="flex content-center justify-between flex-wrap h-[20px] relative cursor-pointer hover-bg mx-[6px]">
                    <ul className="flex justify-between items-center content-center text-[12px] px-[6px] w-full">
                      <li className="w-[30%] text-left iM4qYuTmSKgPwRPj1yPH">
                        {formatNumber(
                          (tokenDetail.quote.USD.price * 0.948).toFixed(4)
                        )}
                      </li>
                      <li className="text-secondaryText text-right w-[35%] mr-2">
                        {getRandomNumber()}
                      </li>
                      <li className="text-secondaryText text-right w-[35%]">
                        {getRandomAmount(5000, 7100)}
                      </li>
                    </ul>
                    <div
                      className="absolute h-full transition-[all] duration-300 ease-out border-x-0 border-solid border-t-1 border-b-1 border-t-headerWhiteMain border-b-headerWhiteMain box-border pointer-events-none I6XCSVa72KszoscrLtcH ZYNLXtcs4UMYH4zjYvyD"
                      style={{
                        width: `${getRandomAmount(10, 40)}%`,
                      }}
                    />
                  </div>
                </div>
                <div className="" style={{ marginTop: 1 }}>
                  <div className="flex content-center justify-between flex-wrap h-[20px] relative cursor-pointer hover-bg mx-[6px]">
                    <ul className="flex justify-between items-center content-center text-[12px] px-[6px] w-full">
                      <li className="w-[30%] text-left iM4qYuTmSKgPwRPj1yPH">
                        {formatNumber(
                          (tokenDetail.quote.USD.price * 0.93).toFixed(4)
                        )}
                      </li>
                      <li className="text-secondaryText text-right w-[35%] mr-2">
                        {getRandomNumber()}
                      </li>
                      <li className="text-secondaryText text-right w-[35%]">
                        {getRandomAmount(1000, 7100)}
                      </li>
                    </ul>
                    <div
                      className="absolute h-full transition-[all] duration-300 ease-out border-x-0 border-solid border-t-1 border-b-1 border-t-headerWhiteMain border-b-headerWhiteMain box-border pointer-events-none I6XCSVa72KszoscrLtcH ZYNLXtcs4UMYH4zjYvyD"
                      style={{
                        width: `${getRandomAmount(0, 40)}%`,
                      }}
                    />
                  </div>
                </div>
                <div className="" style={{ marginTop: 1 }}>
                  <div className="flex content-center justify-between flex-wrap h-[20px] relative cursor-pointer hover-bg mx-[6px]">
                    <ul className="flex justify-between items-center content-center text-[12px] px-[6px] w-full">
                      <li className="w-[30%] text-left iM4qYuTmSKgPwRPj1yPH">
                        {formatNumber(
                          (tokenDetail.quote.USD.price * 0.92).toFixed(4)
                        )}
                      </li>
                      <li className="text-secondaryText text-right w-[35%] mr-2">
                        {getRandomNumber()}
                      </li>
                      <li className="text-secondaryText text-right w-[35%]">
                        {getRandomAmount(10000, 71000)}
                      </li>
                    </ul>
                    <div
                      className="absolute h-full transition-[all] duration-300 ease-out border-x-0 border-solid border-t-1 border-b-1 border-t-headerWhiteMain border-b-headerWhiteMain box-border pointer-events-none I6XCSVa72KszoscrLtcH ZYNLXtcs4UMYH4zjYvyD"
                      style={{
                        width: `${getRandomAmount(8, 80)}%`,
                      }}
                    />
                  </div>
                </div>
                <div className="" style={{ marginTop: 1 }}>
                  <div className="flex content-center justify-between flex-wrap h-[20px] relative cursor-pointer hover-bg mx-[6px]">
                    <ul className="flex justify-between items-center content-center text-[12px] px-[6px] w-full">
                      <li className="w-[30%] text-left iM4qYuTmSKgPwRPj1yPH">
                        {formatNumber(
                          (tokenDetail?.quote?.USD?.price * 0.916).toFixed(4)
                        )}
                      </li>
                      <li className="text-secondaryText text-right w-[35%] mr-2">
                        {getRandomNumber()}
                      </li>
                      <li className="text-secondaryText text-right w-[35%]">
                        {getRandomAmount(10000, 71000)}
                      </li>
                    </ul>
                    <div
                      className="absolute h-full transition-[all] duration-300 ease-out border-x-0 border-solid border-t-1 border-b-1 border-t-headerWhiteMain border-b-headerWhiteMain box-border pointer-events-none I6XCSVa72KszoscrLtcH ZYNLXtcs4UMYH4zjYvyD"
                      style={{
                        width: `${getRandomAmount(10, 80)}%`,
                      }}
                    />
                  </div>
                </div>
                <div className="" style={{ marginTop: 1 }}>
                  <div className="flex content-center justify-between flex-wrap h-[20px] relative cursor-pointer hover-bg mx-[6px]">
                    <ul className="flex justify-between items-center content-center text-[12px] px-[6px] w-full">
                      <li className="w-[30%] text-left iM4qYuTmSKgPwRPj1yPH">
                        {formatNumber(
                          (tokenDetail?.quote?.USD?.price * 0.9).toFixed(4)
                        )}
                      </li>
                      <li className="text-secondaryText text-right w-[35%] mr-2">
                        {getRandomNumber()}
                      </li>
                      <li className="text-secondaryText text-right w-[35%]">
                        {getRandomAmount(1000, 71000)}
                      </li>
                    </ul>
                    <div
                      className="absolute h-full transition-[all] duration-300 ease-out border-x-0 border-solid border-t-1 border-b-1 border-t-headerWhiteMain border-b-headerWhiteMain box-border pointer-events-none I6XCSVa72KszoscrLtcH ZYNLXtcs4UMYH4zjYvyD"
                      style={{
                        width: `${getRandomAmount(1, 70)}%`,
                      }}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default OrderBook;
